<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="流水号：">
          <el-input v-model="formInline.code" placeholder="请输入流水号" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="handleStoreChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾客：">
          <el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in customerInfoList" :label="item.value" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额上限：">
          <el-input v-model="formInline.lessMoney" placeholder="请输入充值金额上限" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="金额下限：">
          <el-input v-model="formInline.moreMoney" placeholder="请输入充值金额下限" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/vip/manage', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
        <el-table-column align="center" slot="code" label="流水号" min-width="200">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleShowDetail(scope.row)">
              {{ scope.row.code }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="customerInfo.gender" label="性别" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.customerInfo.gender == 1" class="one_1">
              {{ formatterFre(scope.row.customerInfo.gender) }}</span>
            <span v-if="scope.row.customerInfo.gender == 0" class="one_2">
              {{ formatterFre(scope.row.customerInfo.gender) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="isConfirm" label="是否确认" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isConfirm == true" class="one_1">
              已确认</span>
            <span v-if="scope.row.isConfirm == false" class="one_2">
              未确认</span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="isFinished" label="是否完成" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isFinished == true" class="one_1">
              已完成</span>
            <span v-if="scope.row.isFinished == false" class="one_2">
              未完成</span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="isPhoneBonus" label="电话提成" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isPhoneBonus == true" class="one_1">
              有</span>
            <span v-if="scope.row.isPhoneBonus == false" class="one_2">
              否</span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="rechargeMoney" label="充值金额" min-width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.rechargeMoney }}元
          </template>
        </el-table-column>
        <el-table-column align="center" slot="bonusMoney" label="赠送金额" min-width="120">
          <template slot-scope="scope">
            <span class="danger" v-if="!isBonusMoneyValid(scope.row.rechargeMoney, scope.row.bonusMoney)">
              ￥{{ scope.row.bonusMoney }}元
            </span>
            <span v-else>
              ￥{{ scope.row.bonusMoney }}元
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="operation" label="操作" min-width="220" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="btnPermission.confirm && scope.row.isConfirm == false" size="mini" type="primary"
              class="el-icon-finished" @click="handleConfirm(scope.row)">
              确认充值
            </el-button>
            <el-button v-if="btnPermission.payArrears && scope.row.isFinished == false && scope.row.amountMoney > 0"
              size="mini" type="primary" class="el-icon-finished" @click="handlePayArrears(scope.row)">
              补欠款
            </el-button>
            <el-button v-if="btnPermission.returnMoney && scope.row.isFinished == true && scope.row.state !=3" size="mini" type="danger"
              class="el-icon-view" @click="handleReturnCard(scope.row)">
              退单
            </el-button>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 补欠款 -->
    <el-dialog :visible.sync="dialogVisible" title="补欠款" style="width: 60%; margin: auto;" append-to-body
      :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付方式:</strong></span>
      <el-select v-model.number="payType.payTypeId" placeholder="请选择支付方式" clearable filterable size="small"
        style="width: 100%;">
        <el-option v-for="item in payTypeList" :label="item.payTypeName" :value="item.payTypeId"
          :key="item.payTypeId"></el-option>
      </el-select>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付金额:</strong></span>
      <el-input v-model.number="payType.payMoney" placeholder="请输入支付金额" style="width: 100%;" size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong>支付备注:</strong></span>
      <el-input v-model="payType.payComment" placeholder="请输入支付备注" style="width: 100%;" size="small"></el-input>
      <span slot="footer">
        <el-button @click="dialogVisible = false" icon="el-icon-close" size="small">取消</el-button>
        <el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting"
          @click="handleSubmitPayArrears">确认</el-button>
      </span>
    </el-dialog>
    <!-- 充值记录详情弹窗 -->
    <detailDialog ref="detailDialog"></detailDialog>
    <!-- 充值记录确认弹窗 -->
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import {
  GetVipRechargeHistoryPageList,
  PayVipRechargeMoney,
  ReturnVIPRecharge
} from "@/api/vipApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import {
  GetCustomerListByStore
} from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detailDialog from "@/views/vip/recharge/detailDialog.vue";
import confirm from "@/views/vip/recharge/confirmRecharge.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "会员充值记录",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        code: "",
        storeKeyId: "",
        customerKeyId: "",
        vipNo: "",
        customerPhone: "",
        lessMoney: "",
        moreMoney: "",
      },
      storeList: [],
      columnsData: [],
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "confirmTime",
          label: "确认时间",
          width: "170",
          align: "center",
          fixed: "left",
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          width: "120",
          align: "center",
          fixed: "left",
        },
        {
          prop: "customerInfo.name",
          label: "会员名称",
          minWidth: "100",
          align: "center",
          fixed: "left",
        },
        {
          slot: "customerInfo.gender",
          label: "性别",
          align: "center",
          width: "80",
          fixed: "left",
        },
        {
          prop: "vipNo",
          label: "会员卡编号",
          width: "160",
          align: "center",
          fixed: "left",
        },
        {
          slot: "rechargeMoney",
          label: "充值金额",
          align: "center",
          width: "100",
        },
        {
          slot: "bonusMoney",
          label: "赠送金额",
          align: "center",
          width: "100",
        },
        {
          slot: "code",
          label: "流水号",
          width: "180",
          align: "center",
        },
        {
          prop: "customerInfo.phone",
          label: "会员电话",
          minWidth: "140",
          align: "center",
        },
        {
          prop: "amountMoney",
          label: "欠款金额",
          align: "center",
          width: "100",
        },
        {
          prop: "totalPayMoney",
          label: "总支付金额",
          align: "center",
          width: "100",
        },
        {
          slot: "isPhoneBonus",
          label: "电话提成",
          align: "center",
          width: "100",
        },
        {
          prop: "stateStr",
          label: "充值状态",
          align: "center",
          width: "100",
          fixed: "right",
        },
        {
          slot: "isConfirm",
          label: "是否确认",
          align: "center",
          width: "100",
        },
        {
          prop: "confirmUserName",
          label: "确认人",
          width: "170",
          align: "center",
        },
        {
          slot: "isFinished",
          label: "是否完成",
          align: "center",
          width: "100",
        },
        {
          prop: "finishedTime",
          label: "完成时间",
          width: "170",
          align: "center",
        },
        {
          prop: "creator",
          label: "经办人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "经办时间",
          width: "170",
          align: "center",
        },
        {
          slot: "operation",
          label: "操作",
          align: "center",
        },
      ],
      customerInfoList: [],
      btnPermission: {
        confirm: false,
        payArrears: false,
        returnMoney: false,
      },
      payTypeList: [],
      payType: {
        keyId: '',
        payTypeId: 1,
        payMoney: 0,
        payComment: "",
      },
      dialogVisible: false,
      isSubmitting: false,
    };
  },
  // 注册组件
  components: {
    detailDialog,
    confirm,
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrgInfoListByConfig();
    this.GetEnumConfigListByCode();

    // 按钮权限
    this.getBtnPermission();
  },
  computed: {},
  methods: {
    // 按钮权限
    getBtnPermission() {
      this.btnPermission.confirm = this.$checkBtnPermission('/vip/rechargeHistory', 'confirm');
      this.btnPermission.payArrears = this.$checkBtnPermission('/vip/rechargeHistory', 'payArrears');
      this.btnPermission.returnMoney = this.$checkBtnPermission('/vip/rechargeHistory', 'returnMoney');
    },
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取人员信息绑定下拉框_根据权限
    GetUserBindSelectByPermission() {
      const paramer = {};
      GetUserBindSelectByPermission(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.userList = [];
            if (res.code == 1) {
              this.userList = res.data;
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取人员信息失败!");
        });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetVipRechargeHistoryPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 性别
    formatterFre(gender) {
      return gender == 1 ? "男" : gender == 0 ? "女" : "";
    },
    // 获取客户信息列表
    GetCustomerListByStore(val) {
      const paramer = {
        keyId: val,
      };
      GetCustomerListByStore(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.customerInfoList = [];
            if (res.code == 1) {
              this.customerInfoList = res.data;
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取客户信息失败!");
        });
    },
    // 确认充值
    handleConfirm(row) {
      this.$refs.confirm.getConfirmDialog(row);
    },
    // 充值记录补款
    handlePayArrears(row) {
      this.payType.keyId = row.keyId;
      this.dialogVisible = true;
    },
    // 充值记录补款弹窗
    handleSubmitPayArrears() {
      // 表单验证
      if (!this.payType.payTypeId) {
        this.$message.error('请选择支付方式');
        return;
      }

      if (typeof this.payType.payMoney !== 'number' || isNaN(this.payType.payMoney)) {
        this.$message.error('请输入有效的数字金额');
        return;
      }

      if (!this.payType.payMoney || this.payType.payMoney <= 0) {
        this.$message.error('请输入有效的支付金额（必须大于0）');
        return;
      }

      this.$confirm('确认补款吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isSubmitting = true;
        PayVipRechargeMoney(this.payType)
          .then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "充值记录补款成功！",
              });
              this.getListData();
              this.dialogVisible = false;
              this.payType = {
                keyId: '',
                payTypeId: 1,
                payMoney: 0,
                payComment: "",
              };
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("充值记录补款失败，请稍后再试！");
          });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消充值记录补款",
        });
      }).finally(() => {
        this.isSubmitting = false;
      });
    },
    //获取状态信息
    GetEnumConfigListByCode() {
      const paramer = {
        code: "PayType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.payTypeList = [];
            res.data.forEach((item) => {
              this.payTypeList.push({
                payTypeId: parseInt(item.code),
                payTypeName: item.name,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    // 验证赠送金额是否符合规则
    isBonusMoneyValid(rechargeMoney, bonusMoney) {
      // 根据充值金额计算应有的赠送金额
      let expectedBonus = 0;
      if (rechargeMoney >= 1000 && rechargeMoney < 2000) {
        expectedBonus = 100;
      } else if (rechargeMoney >= 2000 && rechargeMoney < 3000) {
        expectedBonus = 200;
      } else if (rechargeMoney >= 3000 && rechargeMoney < 5000) {
        expectedBonus = 500;
      } else if (rechargeMoney >= 5000) {
        expectedBonus = 1000;
      }
      // 返回实际赠送金额是否与预期相符
      return bonusMoney === expectedBonus;
    },
    // 显示充值记录详情弹窗
    handleShowDetail(row) {
      this.$refs.detailDialog.getDetailDialog(row);
    },
    // 门店改变时获取客户列表
    handleStoreChange(val) {
      this.GetCustomerListByStore(val);
    },
    // 会员卡退卡充值
    handleReturnCard(row) {
      this.$confirm("确认充值记录退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ReturnVIPRecharge({
          keyId: row.keyId,
        })
          .then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "充值记录退款成功！",
              });
              this.getListData();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("充值记录退款失败，请稍后再试！");
          });
      });
    },
  },
};
</script>

<style scoped>
.red-text {
  color: red;
}

.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}

.danger {
  background: red;
  color: white;
  border-radius: 2px;
  width: 100%;
  height: 100%;
  display: inline-block;
}
</style>